var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"campaign-list",attrs:{"fluid":"","grid-list-lg":""}},[_c('CampaignList',{staticClass:"transition-div"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }